import { useEffect } from 'react'
import { useStatsStore } from '../stores/statsStore'

// Global flag to track if stats have been fetched this session
let globalStatsFetched = false

export const useStats = () => {
  const { stats, isLoading, error, fetchStats } = useStatsStore()

  useEffect(() => {
    // Only fetch once per page load/session
    if (!stats && !isLoading && !globalStatsFetched) {
      globalStatsFetched = true
      fetchStats()
    }
  }, [stats, isLoading])

  const refetch = () => {
    fetchStats()
  }

  return {
    stats,
    isLoading,
    error,
    refetch,
  }
}